module.exports = __webpack_public_path__ + "static/media/partner-logo18.24861719.png";